import { lazy } from 'react'

export const UserLogsLazy = lazy(() => import('./UserLogs'))
